<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="form-heading title-section form-section row mr-0 ml-0 special-header header-title">
              <h1 class="form-title col-md-4 mr-0 pl-0">
                Confirm Eligibility for the “Self-Rated” Program
              </h1>
              <p class="col-md-4">
                For the Applicant to be eligible for E&O Self-Rating, the responses to questions 1-4 below must all be TRUE. If the Applicant
                answers FALSE to any of these questions, please complete a Standard Real Estate Appraisers E&O Application:
              </p>
              <img
                src="../../../public/assets/images/pillar.png"
                style="width: 234px;"
                class="title-section-img form-title-img risk-mgt-img col-md-4"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">1.</span>
                    The applicant holds a valid state license or certification in each state in which he/she provides appraisal services.  If you are a Trainee, you have passed the initial exam (if required) or any other state requirements.
                  </label>
                </div>
                <div class="col-md-4 justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="isTrainee"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.isTrainee"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="isTrainee"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.isTrainee"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('isTrainee')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('isTrainee') | filterText }}</span>
                </div>
              </div>
              <p v-show="axApplication.isTrainee === false" class="text-danger text-center mt-4">
                Please stop and call OREP at 888-347-5273 for an alternative application.
              </p>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">2.</span>
                    The applicant does not appraise any real estate in which he/she has an ownership interest.
                  </label>
                </div>
                <div class="col-md-4 justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doNotAppraiseAnyRealEstate"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.doNotAppraiseAnyRealEstate"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doNotAppraiseAnyRealEstate"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.doNotAppraiseAnyRealEstate"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doNotAppraiseAnyRealEstate')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doNotAppraiseAnyRealEstate') | filterText }}</span>
                </div>
              </div>
              <p v-show="axApplication.doNotAppraiseAnyRealEstate === false" class="text-danger text-center mt-4">
                Please stop and call OREP at 888-347-5273 for an alternative application.
              </p>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">3.</span>
                    The applicant has not been disciplined or investigated by any state licensing, administrative or regulatory board as a result of appraisal activities within the past 5 years.
                  </label>
                </div>
                <div class="col-md-3 justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="notDisciplinedByAnyState"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.notDisciplinedByAnyState"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="notDisciplinedByAnyState"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.notDisciplinedByAnyState"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('notDisciplinedByAnyState')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('notDisciplinedByAnyState') | filterText }}</span>
                </div>
              </div>
              <p v-show="axApplication.notDisciplinedByAnyState === false" class="text-danger text-center mt-4">
                If you’ve had a state board inquiry, complaint, or claim in the last 5 years, please email <a href="mailto:appraisers@orep.org" target="_top">appraisers@orep.org</a> a short explanation. If you have already reported it to OREP, please send an email confirming the status.
              </p>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8">
                  <label for class="orep-label">
                    <span class="mr-2">4.</span>
                    There have been no claims reported and/or pending circumstances which could result in a claim made against the applicant within the past 5 years.
                  </label>
                </div>
                <div class="col-md-4 justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="noClaimsReported"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.noClaimsReported"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="noClaimsReported"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.noClaimsReported"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('noClaimsReported')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('noClaimsReported') | filterText }}</span>
                </div>
              </div>
              <p v-show="axApplication.noClaimsReported === false" class="text-danger text-center mt-4">
                If you’ve had a state board inquiry, complaint, or claim in the last 5 years, please email <a href="mailto:appraisers@orep.org" target="_top">appraisers@orep.org</a> a short explanation. If you have already reported it to OREP, please send an email confirming the status.
              </p>
            </article>

            <article class="form-heading title-section form-section d-flex">
              <h2 class="form-title">
                Residential vs. Commercial Premiums
              </h2>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8">
                  <label for class="orep-label">
                    <span class="mr-2">5.</span>
                    In the last fiscal year, 80% or more of my appraisal revenues have been derived from residential appraisals.
                  </label>
                </div>
                <div class="col-md-4 justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="revenueIsDerivedFromResidentialAppraisals"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.revenueIsDerivedFromResidentialAppraisals"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="revenueIsDerivedFromResidentialAppraisals"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.revenueIsDerivedFromResidentialAppraisals"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('revenueIsDerivedFromResidentialAppraisals')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('revenueIsDerivedFromResidentialAppraisals') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8">
                  <label for class="orep-label">
                    <span class="mr-2">6.</span>
                    Within the last fiscal year, I have not appraised any properties valued at greater than $3,000,000.
                  </label>
                </div>
                <div class="col-md-4 justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="notAppraisedAnyProperties"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.notAppraisedAnyProperties"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="notAppraisedAnyProperties"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.notAppraisedAnyProperties"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('notAppraisedAnyProperties')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('notAppraisedAnyProperties') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8">
                  <label for class="orep-label">
                    <span class="mr-2">7.</span>
                    The applicant’s combined total gross revenues for the last three (3) years did not exceed $500,000.
                  </label>
                </div>
                <div class="col-md-4 justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="totalGrossRevenueNotExceed"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.totalGrossRevenueNotExceed"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="totalGrossRevenueNotExceed"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="axApplication.totalGrossRevenueNotExceed"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('totalGrossRevenueNotExceed')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('totalGrossRevenueNotExceed') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8">
                  <label for class="orep-label">
                    <span class="mr-2">8.</span>
                    In the last 5 years, I have not appraised any Commercial Office Buildings valued at over $3 million.
                  </label>
                </div>
                <div class="col-md-4 justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveAnyCommercialOffice"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="axApplication.haveAnyCommercialOffice"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="haveAnyCommercialOffice"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="axApplication.haveAnyCommercialOffice"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('haveAnyCommercialOffice')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('haveAnyCommercialOffice') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="form-heading title-section form-section d-flex" style="height: 145px;" v-if="axApplication.notDisciplinedByAnyState === false  || axApplication.noClaimsReported === false">
              <h4 class="form-title">
                Additional Information for Applicants NOT ELIGIBLE for Self-Rating
              </h4>
            </article>
            <article class="input-section form-section" v-show="axApplication.notDisciplinedByAnyState === false">

              <div class="flex wrap">
                <div class="flex flex-row w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">8.</span>
                      Number of disciplinary actions or investigations in the past 5 years:
                    </label>
                    <input
                      type="text"
                      name="numberOfDisciplinaryActionsInLastFiveYears"
                      v-model="axApplication.numberOfDisciplinaryActionsInLastFiveYears"
                      class="orep-text-input"
                      v-validate="{ required: !axApplication.notDisciplinedByAnyState }"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('numberOfDisciplinaryActionsInLastFiveYears')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('numberOfDisciplinaryActionsInLastFiveYears') | filterText }}</span>
                  </div>
                </div>
              </div>
              <div class="col mt-1 small">
                <p class="input-info">


                  <span class="not-eligible-text text-danger">
                      <i>
                  Please email a summary along with complaint documents to
                   <strong><a href="mailto:appraisers@orep.org" target="_top">appraisers@orep.org</a></strong>
                </i>
                </span>
                </p>
              </div>

            </article>
            <article class="input-section form-section" v-show="axApplication.noClaimsReported === false">
              <div class="flex wrap">
                <div class="flex flex-row w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">9 a.</span>
                      Number of claims or pending circumstances in the past 5 years:
                    </label>
                    <input
                      type="text"
                      name="numberOfClaimsInLastFiveYears"
                      v-model="axApplication.numberOfClaimsInLastFiveYears"
                      class="orep-text-input"
                      v-validate="{ required: !axApplication.noClaimsReported }"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('numberOfClaimsInLastFiveYears')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('numberOfClaimsInLastFiveYears') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section" v-show="axApplication.noClaimsReported === false">
              <div class="flex wrap">
                <div class="flex flex-row w-100">
                  <div class="col-md-9">
                    <label for class="orep-label">
                      <span class="mr-2">9 b.</span>
                      Total incurred losses in the past 5 years:
                    </label>
                    <input
                      type="text"
                      name="numberOfIncurredLossesInLastFiveYears"
                      v-model="axApplication.numberOfIncurredLossesInLastFiveYears"
                      class="orep-text-input"
                      v-validate="{ required: !axApplication.noClaimsReported }"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('numberOfIncurredLossesInLastFiveYears')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('numberOfIncurredLossesInLastFiveYears') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="d-flex flex-row align-items-center pr-1">
                <label class="orep-label mb-0">
                  Select Limits of Coverage:
                </label>
                <select
                  class="orep-select"
                  style="height: 60px;"
                  name="limitOfCoverage"
                  v-model="axApplication.limitOfCoverage"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option value="0.3M/0.6M">$300,000 / $600,000</option>
                  <option value="0.5M/1M">$500,000 / $1,000,000</option>
                  <option value="1M/1M">$1,000,000 / $1,000,000</option>
                  <option value="1M/2M">$1,000,000 / $2,000,000</option>
                </select>
              </div>
              <span
                v-show="errors.has('limitOfCoverage')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('limitOfCoverage') | filterText }}</span>
              <label class="orep-label">
                Many lenders/Financial Institutions require Minimum Aggregate Limit of $1,000,000.
              </label>
            </article>

          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'ax-application-1'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button @click="prev()" class="pagination-dots"></button>
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                :disabled="!state.pageTwoIsValid"
                @click="navigateToNext('ax-application-3')">
              </button>
              <button
                class="pagination-dots"
                :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid"
                @click="navigateToNext('ax-application-4')">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ax-application-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ax-application-6')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageTwoIsValid"
                    :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('ax-application-3')">Next</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Calculating premium...</span>
    </div>
  </div>
</template>

<script>
  import $ from "jquery";
  import router from "@/router";

  export default {
    name: "ax-application-2",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      axApplication() {
        return this.$store.state.axApplication.axApplication;
      },
      state() {
        return this.$store.state.axApplication;
      },
      errorMsg() {
        return this.$store.state.axApplication.errorMsg;
      }
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              text: this.errorMsg,
              duration: 15000
            });
          }
        }
      }
    },
    methods: {
      prev() {
        this.$router.push({
          name: "ax-application-1"
        });
      },

      navigateToNext(routeName) {
        this.getPremium(routeName);
      },

      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageTwoIsValid = true;
            return;
          }
          this.state.pageTwoIsValid = false;
        });
      },

      getPremium(routeName='ax-application-3') {
        this.loading = true;
        this.$store.dispatch('axApplication/getPremium');
        router.push({
          name: routeName,
        });
      }
    },

    mounted() {
      $("html, body").animate(
        {
          scrollTop: $(".page-content").offset().top
        },
        500
      );
    },

    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },
    components: {}
  };
</script>

